<template>
  <div class="skelelton-container">
    <FixedSkeleton
      :main-widget="mainWidget"
      :left-widgets="leftWidgets"
      :right-widgets="rightWidgets"
    />
  </div>
</template>

<script>
  import AlignmentWidget from '../widgets/AlignmentWidget.vue';
  import ReaderWidget from '../widgets/ReaderWidget.vue';
  import SectionBirdsEyeWidget from '../widgets/SectionBirdsEyeWidget.vue';
  import TextSize from '../widgets/TextSize.vue';
  import TextWidth from '../widgets/TextWidth.vue';
  import ShareWidget from '../widgets/ShareWidget.vue';
  import NamedEntitiesWidget from '../widgets/NamedEntities/NamedEntitiesWidget.vue';


  export default {
    computed: {
      mainWidget() {
        return ReaderWidget;
      },
      leftWidgets() {
        return [
          // see style overrides below (based on position)
          SectionBirdsEyeWidget,
          NamedEntitiesWidget,
        ];
      },
      rightWidgets() {
        return [
          ShareWidget,
          TextSize,
          TextWidth,
          AlignmentWidget,
        ];
      },
    },
  };
</script>
<style lang="scss">
#app > div.skelelton-container > div.skeleton > aside.sidebar-wrapper.left.sidebar-left--open.sidebar-right--open > div.sidebar > div > div:nth-child(1) > div.body.fixed {
  min-height: calc(50vh - 46px);
}
#app > div.skelelton-container > div.skeleton > aside.sidebar-wrapper.left > div.sidebar > div > div:nth-child(2) > div.body.fixed {
  min-height: calc(30vh);
}
</style>
